<ng-container *transloco="let t; read: 'findMyAgent.results.footer'">
  <ng-container *ngTemplateOutlet="footerItemTemplate; context: { $implicit: 'policy' }" />
  <div class="bg-steel-100 my-6 h-[1px] w-full opacity-[.13] md:mx-6 md:my-0 md:h-auto md:w-[2px] md:self-stretch" role="separator"></div>
  <ng-container *ngTemplateOutlet="footerItemTemplate; context: { $implicit: 'lock' }" />

  <ng-template #footerItemTemplate let-item>
    <div class="flex flex-col items-center space-y-2">
      <rma-icon class="!text-6xl" class="text-blue-90" [glyph]="item" />
      <p class="text-center" [innerHTML]="t(item)"></p>
    </div>
  </ng-template>
</ng-container>
